/**
 * Drawer for cart extended from generic drawer element
 */
import Drawer from './drawer';

class DrawerNavigation extends Drawer {
    constructor() {
        super();
    }

    closeDrawer() {
        this.drawerEl.classList.remove('submenu-visible');

        super.closeDrawer()
    }
}

customElements.define('w3-drawer-navigation', DrawerNavigation);